import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

import { AuthAndACLService } from './../auth_and_acl/authAndACL.service';

@Component({
  selector: 'app-login-aluno',
  templateUrl: './login-aluno.component.html',
  styleUrls: ['./login-aluno.component.css'],
  providers:[AuthAndACLService]
})
export class LoginAlunoComponent implements OnInit {
  titulo: string = "Entrar";

  public credencial:any = {login:'', senha: ''};

  constructor(public authAndACL: AuthAndACLService, private route: ActivatedRoute, private router: Router) { }

  logar(): void{
    this.authAndACL.autenticaAlunoExterno(this.credencial)
      .then((response) => this.gravarTokenERedirecionar(response));
  }

  cadastro(): void{
    this.router.navigate(['/cadastro' ]);

  }

  lembra_senha(): void{
    this.router.navigate(['/lembra_senha' ]);

  }

  gravarTokenERedirecionar(response: any):void{
    this.authAndACL.dadosUsuario(response.path,response.token);
  }

  ngOnInit() {
    console.log(localStorage.getItem('tipo_documento'));
    console.log(localStorage.getItem('numero_documento'));
      console.log(localStorage.getItem('nome'));
  }

}



// WEBPACK FOOTER //
// ./src/app/login-aluno/login-aluno.component.ts